var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner',{attrs:{"company-name":"禾祺科技","title":"资质荣誉","description":"相信梦想并坚持，我们就能到达想要的未来。","background-url":require('@/assets/images/nav/ry2.jpeg')}}),_c('aptitude')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }